import React from 'react'
import { numberInput } from '../../../../store/pos/posAction'
import { useDispatch, useSelector } from 'react-redux';

function EnterClick() {
    const dispatch = useDispatch();
    const input = useSelector((state: any) => state.pos);
    return (
        <div className="enter_model">
            <div className="enter_model_content">
                <h2>Enter Amount</h2>
                <input
                    type="text"
                    value={input.enterAmount}
                    onChange={(e) => dispatch(numberInput(e.target.value))}
                />
                <button type="button">Close</button>
            </div>
        </div>
    )
}

export default EnterClick
